import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://c90babaa62ae891224179a558c7dcc8d@o4509917521379328.ingest.de.sentry.io/4509917544120400',
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.MODE,
});
